import React, { useContext } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { IUseApiProps } from '../useApi';
import GiaaReportCls from './GiaaReportCls';
import { OrbUserContext } from '../OrbUserContext';

export interface IGiaaReportProps extends IUseApiProps, IWithErrorHandlingProps {
}

const GiaaReport = (props: IGiaaReportProps) => {
    const { userPermissions } = useContext(OrbUserContext);
    return (
        <ErrorBoundary>
            <GiaaReportCls
                userPermissions={userPermissions}
                {...props}
            />
        </ErrorBoundary>
    );
};

export default withErrorHandling(GiaaReport);
